<template>
  <v-card>
    <v-card-title>
      <span class="text-h5">{{ $t('MESSAGE.REALLY_WANT_TO_REMOVE') }}</span>
    </v-card-title>

    <v-card-text>
      <v-container>
        <v-layout align-center justify-space-between row>
          <v-btn outlined text @click="cancel">{{ $t('BUTTON.CANCEL') }}</v-btn>
          <v-btn color="error" :loading="loading" @click="remove">
            {{ $t('BUTTON.DELETE') }}
          </v-btn>
        </v-layout>
      </v-container>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: 'RelationsCompanyDelete',

  props: {
    id: {
      type: Number,
      required: true
    }
  },

  computed: {
    loading() {
      return this.$store.getters['loading'];
    }
  },

  methods: {
    cancel() {
      this.$emit('cancel');
    },

    remove() {
      this.$store
        .dispatch('relation/remove', {
          type: 'company',
          related_id: this.id.toString()
        })
        .then(({ data }) => {
          this.$store.commit('snackbar/setSnack', {
            status: 'success',
            text: this.$t('MESSAGE.SUCCESS')
          });
          this.$emit('success', data);
          this.$store.commit('loading', false);
        });
    }
  }
};
</script>
